import styled from 'styled-components';
import theme from 'shared/theme';
import { Link } from 'react-router-dom';
import { MEDIA_BREAK } from 'src/components/layout';

export const Nav = styled.div`
  display: flex;
  background: ${theme.brand.blue};
  border-bottom: 1px solid ${theme.brand.border};
  color: ${theme.brand.default};
  font-size: 14px;
  font-weight: 400;
  padding: 0 8px 0 0;
  /* flex-direction: column; */
  flex: 0 0 48px;
  height: 100px;
  align-items: center;
  justify-content: space-between;
  /* @media (max-width: ${MEDIA_BREAK}px) {
    width: 100%
  } */
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  display: flex;
  line-height: 1.2;
  padding-left: 48px;
  /* padding-bottom: 20px; */
  flex: 1;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  align-items: center;
`;

export const Action = styled.div`
  display: flex;
  /* padding-top: 18px; */
  padding-left: 48px;
  flex: 1;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  margin-bottom: 10px;
`;

export const AvatarLink = styled(Link)``;
